// @flow
import React from 'react';

import { withHelmet } from 'infrastructure/seo/Helmet';
import SubMenuHeaderContainer from 'containers/header/SubMenuHeaderContainer';
import Breadcrumb from 'components/fragments/Breadcrumb';
import BackgroundImage from 'components/fragments/BackgroundImage';

import type { SourceSetType } from 'types/Article';

export type StateProps = {
  title: string,
  slug_parent: string,
  slug: string,
  titleParent: string,
  description: string,
  featured_media: {
    src: string,
    legend: string,
    size: SourceSetType
  },
  meta_description: string,
  meta_title: string
};

type Props = {
  title: string,
  withSubMenu: boolean
} & StateProps;

const PageNodeHeader = (props: Props) => {
  return (
    <section className="banner">
      {props.featured_media.src !== '' ? (
        <BackgroundImage
          className="banner__thumbnail img-green"
          illustration={props.featured_media.src}
          srcset={props.featured_media.size}
          baliseImg={false}
        />
      ) : (
        <div className="banner__thumbnail img-green" />
      )}
      <div className="container">
        <Breadcrumb
          elements={[
            { name: 'accueil', to: '/' },
            { name: props.titleParent, to: `/${props.slug_parent}` },
            props.title
          ]}
          isDark
        />

        <h1 className="ft-h2">{props.title}</h1>
        <p className="banner__desc">{props.description}</p>
      </div>
      {props.withSubMenu && <SubMenuHeaderContainer subMenuPath={`/${props.slug_parent}/${props.slug}`} />}
    </section>
  );
};

export default withHelmet(PageNodeHeader)((Helmet, pageProps) => {
  const ogimage = pageProps.featured_media.src;
  const ogimagetitle = pageProps.featured_media.title;
  return (
    <Helmet>
      <title>{pageProps.meta_title}</title>
      <meta name={'description'} content={pageProps.meta_description} />
      <meta property={'og:url'} content={window.location.href} />
      <meta property={'og:title'} content={pageProps.meta_title} />
      <meta property={'og:description'} content={pageProps.meta_description} />
      {ogimage && <meta property={'og:image'} content={ogimage} />}
      {(ogimage && ogimagetitle) && <meta property={'og:image:title'} content={ogimagetitle} />}
      <link rel={'canonical'} href={window.location.href} />
    </Helmet>
  );
});
